module.exports = __webpack_public_path__ + "static/media/image.a56651bb.png";